/**
 * Sharekakao
 */
import Config from "./Config";

class Kakaotalk {
  static getKey(loc) {
    if (/plat-lego.korea.ncsoft.corp/.test(loc)) {
      return "1af018ac29fd1c88bf279ca5f999c97f";
    } else if (/ui-static.korea/.test(loc)) {
      return "b5c5048fcf2c4c8376c7047cf4c6d859";
    } else if (/bns.plaync.co/.test(loc)) {
      return "7a41aad1eebf7e5b4b68db7204aeb574";
    } else if (/lineage.plaync.co/.test(loc)) {
      return "cc821832de1815dfefd89696a8328808";
    } else if (/lineagem.plaync.co/.test(loc)) {
      return "cc821832de1815dfefd89696a8328808";
    } else if (/lineage2.plaync.co/.test(loc)) {
      return "5c2686ba412a29a8fb2942339184d320";
    } else if (/aion.plaync.co/.test(loc) || /aionnew.plaync.co/.test(loc)) {
      return "6c3e99b13fbec7bc6c4d699de19d8e3a";
    } else if (/event.plaync.co/.test(loc)) {
      return "938e491a6a7a61dee6ad1293a191d999";
    } else if (/power.plaync.co/.test(loc)) {
      return "b18b4f83affd1baa323d43cb76ccde55";
    } else if (/fb.plaync.co/.test(loc)) {
      return "938e491a6a7a61dee6ad1293a191d999";
    } else if (/pangyam.plaync.co/.test(loc) || /asia.nc.com/.test(loc)) {
      return "fed893c76cbaa6fe574a28bb723c4906";
    } else if (/plaync.co/.test(loc) || /asia.nc.com/.test(loc)) {
      return "787f3aa15494fd0879123c1cce573c9b";
    }
    return "address error";
  }

  static init(nodeId) {
    const _nodeId = nodeId ? nodeId : Config.nodeId;
    const _tmp = this.getButton();
    document.querySelector(_nodeId).insertAdjacentHTML("beforeend", _tmp);
    this.addEvent();
  }

  static getButton() {
    const _tmp = `<button data-share="kakaotalk" class="btn__share--kakaotalk">
            <i class="icon__kakaotalk"></i>
            <span>kakaotalk</span>
        </button>`;

    return _tmp;
  }

  static loadJs(src, callback) {
    let script = document.createElement("script");
    let loaded = false;
    script.setAttribute("src", src);

    if (script.readyState) {
      //IE
      script.onreadystatechange = function() {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          if (!loaded) callback && callback();
          loaded = true;
        }
      };
    } else {
      //Others
      script.onload = () => {
        if (!loaded) callback && callback();
        loaded = true;
      };
    }
    document.getElementsByTagName("head")[0].appendChild(script);
    return false;
  }

  static share(options) {
    const _title =
      options && options.title
        ? options.title
        : Config && Config.title
          ? Config.title
          : "";
    const _image =
      options && options.image
        ? options.image
        : Config && Config.image
          ? Config.image
          : "";
    const _location =
      options && options.location
        ? options.location
        : Config && Config.location
          ? Config.location
          : window.location.href;
    const _desc =
      options && options.desc
        ? options.desc
        : Config && Config.desc
          ? Config.desc
          : "";

    Kakao.Link.sendDefault({
      objectType: "feed",
      content: {
        title: _title,
        imageUrl: _image,
        link: {
          webUrl: _location,
          mobileWebUrl: _location
        },
        description: _desc
      }
    });
  }

  static addEvent() {
    const kakaoKey = this.getKey(window.location.href);
    let _this = this;
    this.loadJs("https://developers.kakao.com/sdk/js/kakao.min.js", () => {
      if (Kakao) {
        Kakao.init(kakaoKey);
        document
          .querySelector("[data-share=kakaotalk]")
          .addEventListener("click", () => {
            _this.share();
          });
      }
    });
  }
}

export default Kakaotalk;
